(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-veri-header]');
    if (!header) return;
    var root = document.documentElement;

    // Headerhöhe messen → --veri-header-height (für padding-top der ersten Section)
    function setHeight() {
      var bar = header.querySelector('.veri-header__bar');
      if (bar) root.style.setProperty('--veri-header-height', bar.getBoundingClientRect().height + 'px'); // subpixelgenau wie live (83.78px)
    }
    setHeight();
    if ('ResizeObserver' in window) {
      new ResizeObserver(setHeight).observe(header.querySelector('.veri-header__bar'));
    } else {
      window.addEventListener('resize', setHeight);
    }

    var burger = header.querySelector('[data-veri-burger]');
    var menu = header.querySelector('[data-veri-menu]');
    if (!burger || !menu) return;
    var label = burger.querySelector('[data-veri-burger-label]');
    var focusables = function () { return menu.querySelectorAll('a'); };

    function setOpen(open) {
      root.classList.toggle('veri-menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (label) label.textContent = burger.getAttribute(open ? 'data-label-close' : 'data-label-open');
      focusables().forEach(function (a) { a.tabIndex = open ? 0 : -1; });
    }

    burger.addEventListener('click', function () {
      setOpen(!root.classList.contains('veri-menu-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('veri-menu-open')) {
        setOpen(false);
        burger.focus();
      }
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    // Header-Umschaltpunkt wie im CSS: zurück auf Desktop → Menü schließen
    window.matchMedia('(max-width: 799px), (pointer: coarse) and (max-width: 1024px)').addEventListener('change', function (mq) {
      if (!mq.matches) setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veri-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Nur ein Eintrag gleichzeitig offen (wenn „Mehrere gleichzeitig öffnen“ aus ist)
    document.addEventListener(
      'toggle',
      function (event) {
        var item = event.target;
        if (!item.matches || !item.matches('.veri-accordion__item') || !item.open) return;
        var list = item.closest('[data-veri-accordion-single]');
        if (!list) return;
        list.querySelectorAll('.veri-accordion__item[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veri-cart"]) return;
  try {
    
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function sectionEl(node) {
      return node.closest('[data-veri-cart-section]');
    }

    function change(section, line, quantity) {
      var sectionId = section.getAttribute('data-section-id');
      section.classList.add('is-loading');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().then(function (json) {
            if (!r.ok) throw json;
            return json;
          });
        })
        .then(function (cart) {
          var html = cart.sections && cart.sections[sectionId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-veri-cart-section]');
            if (fresh) section.innerHTML = fresh.innerHTML;
          }
          if (window.VeriCart) window.VeriCart.setCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('veri:cart:updated', { detail: { cart: cart } }));
        })
        .catch(function (err) {
          var el = section.querySelector('[data-veri-cart-error]');
          if (el) {
            el.textContent = (err && (err.description || err.message)) || '';
            el.hidden = !el.textContent;
          }
        })
        .finally(function () {
          section.classList.remove('is-loading');
        });
    }

    document.addEventListener('click', function (event) {
      var step = event.target.closest('[data-veri-cart-step]');
      if (step) {
        var wrap = step.closest('[data-veri-cart-qty]');
        var input = wrap && wrap.querySelector('[data-veri-cart-input]');
        if (!input) return;
        var value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-veri-cart-step'), 10));
        var max = parseInt(input.max || '9999', 10);
        input.value = Math.min(value, max);
        change(sectionEl(step), parseInt(input.getAttribute('data-veri-cart-input'), 10), parseInt(input.value, 10));
        return;
      }
      var remove = event.target.closest('[data-veri-cart-remove]');
      if (remove) {
        event.preventDefault();
        change(sectionEl(remove), parseInt(remove.getAttribute('data-veri-cart-remove'), 10), 0);
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-veri-cart-input]');
      if (!input) return;
      var value = Math.max(0, parseInt(input.value, 10) || 0);
      change(sectionEl(input), parseInt(input.getAttribute('data-veri-cart-input'), 10), value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veri-legal-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-veri-withdrawal-form]').forEach(function (form) {
        if (form.dataset.veriReady) return;
        form.dataset.veriReady = 'true';
        var step1 = form.querySelector('[data-veri-withdrawal-step="1"]');
        var step2 = form.querySelector('[data-veri-withdrawal-step="2"]');
        var next = form.querySelector('[data-veri-withdrawal-next]');
        var back = form.querySelector('[data-veri-withdrawal-back]');
        var summary = form.querySelector('[data-veri-withdrawal-summary]');
        var confirmText = form.querySelector('[data-veri-withdrawal-confirm]');
        var time = form.querySelector('[data-veri-withdrawal-time]');
        if (!step1 || !step2 || !next) return;

        form.classList.add('is-enhanced');
        form.querySelectorAll('[data-veri-withdrawal-show-enhanced]').forEach(function (el) { el.hidden = false; });

        function fields() {
          return Array.prototype.slice.call(step1.querySelectorAll('input, textarea'));
        }
        function showStep(n) {
          var confirming = n === 2;
          step1.hidden = confirming;
          step2.hidden = !confirming;
          if (back) back.hidden = !confirming;
          form.classList.toggle('is-confirming', confirming);
          if (confirming && confirmText) confirmText.focus();
          if (!confirming) {
            var first = step1.querySelector('input:not([type=hidden])');
            if (first) first.focus();
          }
        }
        next.addEventListener('click', function () {
          var invalid = fields().filter(function (f) { return !f.checkValidity(); });
          if (invalid.length) {
            invalid[0].reportValidity();
            return;
          }
          summary.innerHTML = '';
          fields().forEach(function (f) {
            if (!f.value) return;
            var dt = document.createElement('dt');
            dt.textContent = f.getAttribute('data-veri-summary') || f.name;
            var dd = document.createElement('dd');
            var value = f.value;
            if (f.type === 'date' && f.valueAsDate) value = f.valueAsDate.toLocaleDateString('de-DE', { timeZone: 'UTC' });
            dd.textContent = value;
            summary.appendChild(dt);
            summary.appendChild(dd);
          });
          showStep(2);
        });
        if (back) back.addEventListener('click', function () { showStep(1); });
        form.addEventListener('submit', function (event) {
          if (!form.classList.contains('is-confirming')) {
            event.preventDefault();
            next.click();
            return;
          }
          if (time) time.value = new Date().toISOString();
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:block:select', function (event) { init(event.target.closest('.shopify-section')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veri-main-product"]) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-veri-gallery]').forEach(function (gallery) {
        if (gallery.dataset.veriGalleryReady) return;
        gallery.dataset.veriGalleryReady = 'true';
        var track = gallery.querySelector('[data-veri-gallery-track]');
        if (!track) return;
        var slides = track.querySelectorAll('[data-veri-gallery-slide]');
        var thumbs = gallery.querySelectorAll('[data-veri-gallery-thumb]');
        var status = gallery.querySelector('[data-veri-gallery-status]');
        var current = 0;

        function setActive(index) {
          current = index;
          thumbs.forEach(function (t, i) {
            if (i === index) t.setAttribute('aria-current', 'true');
            else t.removeAttribute('aria-current');
          });
          if (status && slides[index]) {
            var cap = slides[index].querySelector('figcaption');
            status.textContent = cap ? cap.textContent : '';
          }
        }
        function goTo(index) {
          if (!slides.length) return;
          index = (index + slides.length) % slides.length;
          track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          setActive(index);
        }
        gallery.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-veri-gallery-thumb]');
          if (thumb) return goTo(parseInt(thumb.getAttribute('data-veri-gallery-thumb'), 10));
          if (event.target.closest('[data-veri-gallery-prev]')) return goTo(current - 1);
          if (event.target.closest('[data-veri-gallery-next]')) return goTo(current + 1);
        });
        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
        });
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            if (index !== current) setActive(index);
          });
        }, { passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    // Anker #inhaltsstoffe: INCI-Bereich beim Sprung automatisch öffnen
    function openInci() {
      if (!window.location.hash) return;
      var el = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      if (el && el.matches('[data-veri-inci]')) el.open = true;
    }
    openInci();
    window.addEventListener('hashchange', openInci);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veri-marquee"] && !Shopify.designMode) return;
  try {
    
  /* veri-marquee: Laufzeit aus Gruppenbreite und Squarespace-„Speed“ (Annahme: Speed = px pro Frame @60fps). */
  (function () {
    function initMarquee(root) {
      var track = root.querySelector('[data-veri-marquee-track]');
      if (!track) return;
      var group = track.firstElementChild;
      var speed = parseFloat(root.getAttribute('data-speed')) || 0.5;
      function update() {
        var w = group ? group.getBoundingClientRect().width : 0;
        if (w <= 0) return;
        root.style.setProperty('--veri-marquee-duration', (w / (speed * 60)).toFixed(2) + 's');
        /* Startversatz: erster Eintrag beginnt beim Laden bei x = Versatz (wie live beobachtet) */
        var mobile = window.matchMedia('(max-width: 767px)').matches;
        var offset = parseFloat(root.getAttribute(mobile ? 'data-offset-m' : 'data-offset-d')) || 0;
        var m = (((offset % w) + w) % w) - w;
        track.style.marginLeft = m.toFixed(2) + 'px';
      }
      update();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(group);
      window.addEventListener('resize', update);
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('[data-veri-marquee]').forEach(initMarquee);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veri-quote-carousel"] && !Shopify.designMode) return;
  try {
    
  /* veri-quote-carousel: Slides liegen gestapelt im selben Grid-Feld, Position per --pos (Slide-Breite + 20px).
     Endlos: Positionen modulo Anzahl, der letzte Slide liegt links (-1). Sprünge ohne Animation. */
  (function () {
    function initQuotes(root) {
      if (root.__veriQuotes) return;
      root.__veriQuotes = true;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-veri-quote-slide]'));
      var n = slides.length;
      if (n < 2) return;
      var loop = root.getAttribute('data-loop') === 'true';
      var prev = root.querySelector('[data-veri-quotes-prev]');
      var next = root.querySelector('[data-veri-quotes-next]');
      var current = 0;
      var positions = slides.map(function (el) { return parseInt(el.style.getPropertyValue('--pos'), 10) || 0; });

      function render() {
        slides.forEach(function (el, i) {
          var pos = i - current;
          if (loop) {
            pos = ((pos % n) + n) % n;
            if (pos === n - 1) pos = -1;
          }
          if (Math.abs(pos - positions[i]) > 1) {
            el.classList.add('is-jump');
            requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-jump'); }); });
          }
          positions[i] = pos;
          el.style.setProperty('--pos', pos);
          if (pos === 0) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
        if (!loop) {
          if (prev) prev.disabled = current === 0;
          if (next) next.disabled = current === n - 1;
        }
      }
      function go(delta) {
        current = loop ? (((current + delta) % n) + n) % n : Math.min(n - 1, Math.max(0, current + delta));
        render();
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(-1);
        if (e.key === 'ArrowRight') go(1);
      });
      render();
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('[data-veri-quotes]').forEach(initQuotes);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
